var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('NavigationBar'),_c('Breadcrumb',{attrs:{"breadcrumbText":"Food Menu"}}),_c('FoodMenu'),_c('Video'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }